import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=652e8284&scoped=true&"
import script from "./Rooms.vue?vue&type=script&lang=js&"
export * from "./Rooms.vue?vue&type=script&lang=js&"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=652e8284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e8284",
  null
  
)

export default component.exports